import { render } from "./GroupMatrix.vue?vue&type=template&id=5d59136c&scoped=true"
import script from "./GroupMatrix.vue?vue&type=script&lang=js"
export * from "./GroupMatrix.vue?vue&type=script&lang=js"

import "./GroupMatrix.vue?vue&type=style&index=0&id=5d59136c&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d59136c"]])

export default __exports__